import { scanContactCaptures } from './mount';
import { startBuilderPreview } from './preview';

declare global {
  interface Window {
    BHIContactCapture?: {
      scan: () => void;
      version: string;
    };
    __bhiContactCaptureObserver?: MutationObserver;
  }
}

const currentScript = document.currentScript instanceof HTMLScriptElement
  ? document.currentScript
  : null;

const boot = () => {
  if (currentScript?.dataset.contactCaptureBuilderPreview === 'true' && window.parent !== window) {
    startBuilderPreview();
    return;
  }
  scanContactCaptures(currentScript);
  window.BHIContactCapture = {
    scan: () => scanContactCaptures(),
    version: '0.1.0',
  };

  if (!window.__bhiContactCaptureObserver) {
    // Customer pages mutate constantly, so rescans are coalesced into one per frame.
    let scanScheduled = false;
    const observer = new MutationObserver(() => {
      if (scanScheduled) return;
      scanScheduled = true;
      window.requestAnimationFrame(() => {
        scanScheduled = false;
        scanContactCaptures();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.__bhiContactCaptureObserver = observer;
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}

export { normalizePublicConfig } from './config';
export { mountContactCapture, scanContactCaptures } from './mount';
